const actionPrefix = (actionType) => `Api/${actionType}`;

export const ADD_ABORTABLE_REQUEST = actionPrefix('ADD_ABORTABLE_REQUEST');
export const addAbortableRequest = (payload) => ({
  type: ADD_ABORTABLE_REQUEST,
  payload,
});

export const REMOVE_ABORTABLE_REQUEST = actionPrefix('REMOVE_ABORTABLE_REQUEST');
export const removeAbortableRequest = (url) => ({
  type: REMOVE_ABORTABLE_REQUEST,
  payload: url,
});

export const apiActions = {
  removeAbortableRequest,
};
